import action from '../helpers/rest-client';
import {
  GetCommentsOutDto,
  CreateCommentOutDto,
  DeleteCommentOutDto,
} from '../types/comment.dto';

class Comment {
  public async getComments({ post_id, page = 1, perPage = 20 }: GetCommentsOutDto) {
    return action
      .Get({
        url: `/api/post-comment?post_id=${post_id}&page=${page}&perPage=${perPage}`,
      })
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  public async createComment({ post_id, body, parent_id }: CreateCommentOutDto) {
    return action
      .Post({
        url: `/api/post-comment`,
        body: { post_id, body, ...(parent_id !== undefined && { parent_id }) },
      })
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  public async deleteComment({ id }: DeleteCommentOutDto) {
    return action
      .Del({
        url: `/api/post-comment/${id}`,
      })
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }
}

const comment = new Comment();
export default comment;
